import { APIClient } from './APIClient'

export const fetchConfidenceStatements = (language) => {
    return APIClient.get(`/v1/${language}/statements/confidence`, language)
}
